import DashboardCards from "Components/Dashboard/DashboardCards";
import MainLayout from "Layouts/MainLayout";

const Dashboard = () => {
  return <DashboardCards />;
};

export default Dashboard;
